document.addEventListener('DOMContentLoaded', function() {
    // Province age mapping
    const provinceAges = {
      'Alberta': 18,
      'British Columbia': 19,
      'Manitoba': 18,
      'New Brunswick': 19,
      'Ontario': 19,
      'Saskatchewan': 19
    };
  
    // Get province pages from global object
    const pages = window.ageGatingV2Pages || {};
  
    // Get cookie value
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
  
    // Set cookie
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
    }

    // Prevent/restore scrolling
    function preventScrolling() {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      // Additional prevention for mobile
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    }

    function restoreScrolling() {
      const scrollY = document.body.style.top;
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    }
  
    // Update button text based on province
    function updateButtonText(province) {
      const age = provinceAges[province] || 19;
      const verifyButton = document.getElementById('age-gating-v2__verify');
      const notVerifyButton = document.getElementById('age-gating-v2__not-verify');
      
      if (verifyButton) {
        verifyButton.textContent = `I AM ${age} OR OVER`;
      }
      if (notVerifyButton) {
        notVerifyButton.textContent = `I AM NOT ${age}`;
      }
    }
  
    // Show verification section
    function showVerificationSection() {
      const verificationSection = document.getElementById('age-gating-v2__verification-section');
      if (verificationSection) {
        verificationSection.style.display = 'flex';
        verificationSection.classList.add('active');
        verificationSection.style.opacity = '1';
        verificationSection.style.transform = 'translateY(0)';
      }
    }
  
    // Update other province selectors when location changes
    function updateOtherProvinceSelectors(selectedProvince) {
      const desktopSelector = document.querySelector('#provinces');
      const mobileSelector = document.querySelector('#megamenu-mobile #provinces');
      
      if (desktopSelector && desktopSelector.value !== selectedProvince) {
        desktopSelector.value = selectedProvince;
      }
      if (mobileSelector && mobileSelector.value !== selectedProvince) {
        mobileSelector.value = selectedProvince;
      }
    }
  
    // Province selector handling
    const provinceSelect = document.getElementById('age-gating-provinces-v2');
    if (provinceSelect) {
      // Set current province if available
      const currentProvince = getCookie('location');
      if (currentProvince && currentProvince !== 'not-selected') {
        provinceSelect.value = currentProvince;
        updateButtonText(currentProvince);
        showVerificationSection();
      }
  
      provinceSelect.addEventListener('change', function() {
        const selectedProvince = this.value;
        
        if (selectedProvince !== 'not-selected') {
          // Set location cookie immediately
          setCookie('location', selectedProvince, 365);
          
          // Update other province selectors
          updateOtherProvinceSelectors(selectedProvince);
          
          // Update button text
          updateButtonText(selectedProvince);
          
          // Show verification section
          showVerificationSection();
        }
      });
    }
  
    // Check if province has a specific page
    function getProvincePageUrl(province) {
      const provinceMap = {
        'Ontario': pages.ontario,
        'British Columbia': pages.britishColumbia,
        'Alberta': pages.alberta,
        'Manitoba': pages.manitoba,
        'New Brunswick': pages.newBrunswick,
        'Saskatchewan': pages.saskatchewan
      };
      
      const pageUrl = provinceMap[province];
      // Return province page if it exists and is not the default '/', otherwise return null
      return (pageUrl && pageUrl !== '/') ? pageUrl : null;
    }
  
    // Hide age gating with smooth transition
    function hideAgeGating() {
      const ageGatingElement = document.querySelector('.age-gating-v2');
      if (ageGatingElement) {
        ageGatingElement.style.opacity = '0';
        setTimeout(() => {
          ageGatingElement.style.display = 'none';
          restoreScrolling();
        }, 300);
      }
    }
  
    // Verify button handling
    const verifyButton = document.getElementById('age-gating-v2__verify');
    if (verifyButton) {
      verifyButton.addEventListener('click', function() {
        const selectedProvince = provinceSelect ? provinceSelect.value : null;
        const rememberCheckbox = document.getElementById('age-gating-v2__cc');
        const days = rememberCheckbox && rememberCheckbox.checked ? 30 : 1;
        
        if (!selectedProvince || selectedProvince === 'not-selected') {
          alert('Please select your province or territory');
          return;
        }
        
        // Add loading state
        verifyButton.classList.add('age-gating-v2__button--loading');
        verifyButton.textContent = 'VERIFYING...';
        verifyButton.disabled = true;
        
        // Set cookies
        setCookie('location', selectedProvince, days);
        setCookie('verified', 'true', days);
        
        // Check if province has a specific page
        const provincePageUrl = getProvincePageUrl(selectedProvince);
        
        setTimeout(() => {
          if (provincePageUrl) {
            // Redirect to province-specific page
            window.location.href = provincePageUrl;
          } else {
            // Reload current page
            window.location.reload();
          }
        }, 500); // Small delay to show loading state
      });
    }
  
    // Not verify button handling (modal)
    const notVerifyButton = document.getElementById('age-gating-v2__not-verify');
    const modal = document.querySelector('.age-gating-v2__not-of-age-modal');
    const closeButton = document.querySelector('.age-gating-v2__not-of-age-modal-close');
  
    if (notVerifyButton && modal) {
      notVerifyButton.addEventListener('click', function() {
        modal.style.display = 'flex';
      });
    }
  
    if (closeButton && modal) {
      closeButton.addEventListener('click', function() {
        modal.style.display = 'none';
      });
    }
  
    // Close modal when clicking outside
    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          modal.style.display = 'none';
        }
      });
    }

    // Ensure scrolling is prevented when age gating is visible
    const ageGatingElement = document.querySelector('.age-gating-v2');
    if (ageGatingElement && window.getComputedStyle(ageGatingElement).display !== 'none') {
      preventScrolling();
    }

    // Prevent all forms of scrolling when age gating is active
    function preventAllScrolling(e) {
      if (ageGatingElement && window.getComputedStyle(ageGatingElement).display !== 'none') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }

    // Add multiple event listeners to prevent scrolling
    window.addEventListener('wheel', preventAllScrolling, { passive: false });
    window.addEventListener('touchmove', preventAllScrolling, { passive: false });
    window.addEventListener('keydown', function(e) {
      // Prevent arrow keys, page up/down, space, etc.
      if (ageGatingElement && window.getComputedStyle(ageGatingElement).display !== 'none') {
        const scrollKeys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
        if (scrollKeys.includes(e.keyCode)) {
          e.preventDefault();
          return false;
        }
      }
    });
  }); 